var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccessMethod({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H7C6.73333 15 6.48 14.8933 6.29333 14.7067C6.10667 14.52 6 14.2667 6 14V12.5H7V14H13V2H7V3.5H6V2C6 1.73333 6.10667 1.48 6.29333 1.29333C6.48 1.10667 6.73333 1 7 1H13C13.2667 1 13.52 1.10667 13.7067 1.29333C13.8933 1.48 14 1.73333 14 2V14C14 14.2667 13.8933 14.52 13.7067 14.7067C13.52 14.8933 13.2667 15 13 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29333 10.2933L9.08 8.5H2V7.5H9.08667L7.3 5.70667L8.00667 5L11.0067 8L8.00667 11L7.3 10.2933H7.29333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessMethod);
export default __webpack_public_path__ + "static/media/ic-access-method.eda1216426e7550e4cd1531c71aa5809.svg";
export { ForwardRef as ReactComponent };